import Link, { LinkProps } from "next/link";
import { AnchorHTMLAttributes } from "react";
import "./index.scss";

const ButtonLink = ({
  href,
  children,
  className,
  ...remainingProps
}: LinkProps & AnchorHTMLAttributes<HTMLAnchorElement>) => {
  if (href && href.startsWith("/")) {
    return (
      <Link
        href={href}
        className={`component button-link ${className}`}
        {...remainingProps}
      >
        {children}
      </Link>
    );
  } else {
    return (
      <a
        href={href}
        className={`component button-link ${className}`}
        {...remainingProps}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }
};

export default ButtonLink;
